import { Redirect, Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { firestoreConnect } from 'react-redux-firebase';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ThermageLogo from '../../images/thermage_eyes.svg';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//import Divider from '@material-ui/core/Divider';
import Footer from '../Footer';
import LogoHeader from '../Header';
//import CircularProgress from '@material-ui/core/CircularProgress';
import ClinicCodeBlock from '../Clinics/clinicCodeBlock';
import SelectDoctor from '../Clinics/selectDoctorForm';
import ClinicBlock from '../Clinics/clinicBlock';
import { setPromo } from '../../actions/promoActions';
import LoadingBlock from '../Loading';
//import { ThermageButton } from '../Buttons/thermageButton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { closeCompanyPopUps } from '../../actions/companyActions';
import { registerLoggedinUsers } from '../../actions/authActions';

const styles = {
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: 2,
    textAlign: 'left',
    color: '#000',
  },
  customerName: {
    fontFamily: 'Montserrat',
    fontWeight: 300,
    color: '#9b3e96',
    fontSize: 48,
    '@media (max-width: 1025px)': {
      fontSize: 28,
    },
    '@media (max-width: 599px)': {
      textAlign: 'center',
    },
  },
  logo: {
    marginTop: 30,
    width: 155,
    display: 'block',
    '@media (max-width: 1025px)': {
      width: 135,
      marginLeft: -40,
      marginTop: 0,
    },
  },
  alignCenter: {
    textAlign: 'center',
  },
  questionMark: {
    right: -50,
    display: 'block',
    position: 'absolute',
    top: 0,
    '@media (max-width: 1440px)': {
      right: -70,
    },
    '@media (max-width: 1300px)': {
      right: -85,
    },
    '@media (max-width: 1025px)': {
      right: -30,
    },
    '@media (max-width: 850px)': {
      right: -50,
    },
    '@media (max-width: 599px)': {
      right: -30,
    },
  },
  logoBlock: {
    position: 'relative',
    display: 'block',
  },
  mobileCenter: {
    '@media (max-width: 599px)': {
      textAlign: 'center',
    },
  },
};

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const INITIAL_STATE = {
  //pagePromo: 'olff8ViVEXKmuBK179Zs', //This is the id of the promo, this will change to load from the url once we have more then one promo,
  loading: true,
};

class HomePageBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  componentDidUpdate() {
    //this.setState({ loading: true });
    if (this.state.loading) {
      if (this.props.promos) {
        if (this.props.promos.length === 1) {
          //console.log('we only have one promo', this.props.promos[0].id)
          this.props.setPromo(this.props.promos[0].id);
          this.setState({
            loading: false,
          });
        }
      }
    }
  }

  closePopUps = () => {
    this.props.closeCompanyPopUps();
  };

  findUser = () => {
    this.props.registerLoggedinUsers(this.props.auth);
  };

  render() {
    const {
      //pagePromo
      loading,
    } = this.state;

    const { auth, t, classes, user, companyError, companyMessage, selectedCompany, promoID, companyErrorPopUp, companyPopUp, userChecked } = this.props;
    //console.log('this is my auth', auth);

    if (!auth.uid) return <Redirect to={ROUTES.LOGIN} />;

    if (user.isLoaded && !user.isEmpty && !loading) {
      return (
        <div className='meta-react'>
          <LogoHeader t={t} />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className={classes.root}>
                  <Grid container spacing={3} justify='center'>
                    <Grid item xs={12} sm={6}>
                      <Typography variant='h3' className={classes.customerName}>
                        {user.fullName}
                      </Typography>
                      <Typography variant='body1' className={classes.mobileCenter}>
                        {t('home.customerNameSecondCopy')}
                      </Typography>

                      <Typography variant='h5' className={classes.mobileCenter}>
                        {user.promos ? user.promos[promoID].promoCode : ''}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={1} alignItems='center' justify='center'>
                        <Grid item xs={3}>
                          <div className={classes.logoBlock}>
                            <Link to={ROUTES.ABOUT} target='_blank' className={classes.purple}>
                              <img src={ThermageLogo} alt='Solta' className={classes.logo} />
                              <HelpOutlineIcon className={classes.questionMark} />
                            </Link>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      {user.promos[promoID].clinic ? <ClinicBlock /> : selectedCompany ? <ClinicCodeBlock /> : <SelectDoctor />}
                    </Grid>
                  </Grid>
                  <Snackbar open={companyPopUp} autoHideDuration={6000} onClose={this.closePopUps}>
                    <Alert onClose={this.closePopUps} severity='success'>
                      {companyMessage}
                    </Alert>
                  </Snackbar>
                  <Snackbar open={companyErrorPopUp} autoHideDuration={6000} onClose={this.closePopUps}>
                    <Alert onClose={this.closePopUps} severity='error'>
                      {companyError}
                    </Alert>
                  </Snackbar>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      );
    } else if (user.isLoaded && user.isEmpty) {
      if (!userChecked) {
        this.findUser();
      } else {
        return (
          <div className='meta-react'>
            <LogoHeader t={t} />
            <div className='container'>
              <div className='row'>
                <div className='col-12'>
                  <div className={classes.root}>
                    <Grid container spacing={3} justify='center'>
                      <Grid item xs={12} align='center'>
                        <Typography variant='h6'>{t('home.clinicUserLoggedIn')}</Typography>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        );
      }
      return (
        <div className='meta-react'>
          <LogoHeader t={t} />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className={classes.root}>
                  <Grid container spacing={3} justify='center'>
                    <Grid item xs={12} align='center'>
                      <LoadingBlock />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      );
    } else {
      return (
        <div className='meta-react'>
          <LogoHeader t={t} />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className={classes.root}>
                  <Grid container spacing={3} justify='center'>
                    <Grid item xs={12} align='center'>
                      <LoadingBlock />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      );
    }
  }
}

HomePageBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  //console.log('this is my state', state);
  return {
    auth: state.firebase.auth,
    user: state.firebase.profile,
    promos: state.firestore.ordered.promos,
    companyError: state.company.companyError,
    companyMessage: state.company.companyMessage,
    companyPopUp: state.company.companyPopUp,
    companyErrorPopUp: state.company.companyErrorPopUp,
    selectedCompany: state.company.company,
    promoID: state.promos.promoID,
    userChecked: state.auth.userChecked,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPromo: (promoID) => dispatch(setPromo(promoID)),
    closeCompanyPopUps: () => dispatch(closeCompanyPopUps()),
    registerLoggedinUsers: (user) => dispatch(registerLoggedinUsers(user)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withTranslation(),
  firestoreConnect((props) => [{ collection: 'promos' }])
)(HomePageBase);
